import { useState } from "react";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

type MainCategory = "중등수학" | "고등수학";
type HighSubCategory = "전체" | "공통수학1" | "공통수학2" | "대수" | "미적분" | "확률과 통계";

interface Video {
  id: number;
  main: MainCategory;
  sub: string;
  title: string;
  link: string;
}

const videos: Video[] = [
  // ──────────────── 공통수학1 ────────────────
  // 다항식
  { id: 54,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 단항식과 다항식",                           link: "https://youtu.be/aTr-TKb9CsY" },
  { id: 52,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 다항식의 지수법칙",                         link: "https://youtu.be/VNxH4pH5lrw" },
  { id: 53,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 다항식의 연산",                             link: "https://youtu.be/_4L9CPo2UrA" },
  { id: 51,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 다항식의 곱셈공식(2)",                      link: "https://youtu.be/tUENNZb6Whk" },
  { id: 32,  main: "고등수학", sub: "공통수학1", title: "고등수학 공통수학1 다항식의 곱셈공식(2)",                  link: "https://youtu.be/53JYg8JSEAM" },
  { id: 50,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 다항식의 곱셈공식(3)",                      link: "https://youtu.be/mjedjkbYSZQ" },
  { id: 5,   main: "고등수학", sub: "공통수학1", title: "[실전문제풀이] 공통수학1 - 곱셈공식의 활용",              link: "https://youtu.be/_RmRYHSEz5Q" },
  { id: 49,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 다항식의 나눗셈",                           link: "https://youtu.be/n8wyuj7Q-uc" },
  { id: 4,   main: "고등수학", sub: "공통수학1", title: "[실전문제풀이] 공통수학1 - 다항식 나머지정리",             link: "https://youtu.be/CAOVPDbvw6Y" },
  { id: 30,  main: "고등수학", sub: "공통수학1", title: "고등수학 공통수학1-1 중간고사대비 - 인수분해",             link: "https://youtu.be/9r7kbtHcoio" },
  { id: 35,  main: "고등수학", sub: "공통수학1", title: "[실전문제풀이] 공통수학 - 다항식",                         link: "https://youtu.be/pWqV-KxBvNE" },
  { id: 129, main: "고등수학", sub: "공통수학1", title: "실전문제풀이 - 공통수학1 - 다항식 (2:32)",                link: "https://youtu.be/Q3LgsJZIj6k" },
  { id: 130, main: "고등수학", sub: "공통수학1", title: "실전문제풀이 - 공통수학1 - 다항식 (3:41)",                link: "https://youtu.be/gpyrDDPEOaM" },
  { id: 136, main: "고등수학", sub: "공통수학1", title: "실전문제풀이 - 공통수학1 - 다항식 (2:59)",                 link: "https://youtu.be/aaSkKvjuiRo" },
  { id: 137, main: "고등수학", sub: "공통수학1", title: "실전문제풀이 - 공통수학1 - 다항식 (4:03)",                 link: "https://youtu.be/taiO_ETSKlw" },
  { id: 138, main: "고등수학", sub: "공통수학1", title: "실전문제풀이 - 공통수학1 - 다항식 (7:16)",                 link: "https://youtu.be/B2FW4-A_9rI" },
  // 복소수
  { id: 57,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학 복소수 (1)",                                link: "https://youtu.be/hKEO43sZu0I" },
  { id: 56,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학 복소수 (2)",                                link: "https://youtu.be/JhIcsJTTACs" },
  { id: 55,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학 복소수 (3)",                                link: "https://youtu.be/S5Zqj0oHb90" },
  { id: 3,   main: "고등수학", sub: "공통수학1", title: "[실전문제풀이] 공통수학1 - 복소수 2",                    link: "https://youtu.be/tUoxwr3_UJY" },
  { id: 6,   main: "고등수학", sub: "공통수학1", title: "[실전문제] 공통수학1 - 복소수",                         link: "https://youtu.be/_ZLBKVThqBA" },
  { id: 127, main: "고등수학", sub: "공통수학1", title: "실전문제풀이 - 공통수학1- 복소수",                        link: "https://youtu.be/ToGQo84EcB8" },
  // 이차방정식
  { id: 42,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 이차방정식의 판별식",                       link: "https://youtu.be/YDrdupi7VBs" },
  { id: 31,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 이차방정식의 해법",                        link: "https://youtu.be/wxS0aUKlOJo" },
  { id: 41,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 이차방정식의 근과 계수와의 관계",            link: "https://youtu.be/10oklgKefdM" },
  { id: 7,   main: "고등수학", sub: "공통수학1", title: "[실전문제] 공통수학1 - 이차방정식의 근과 계수의 관계",     link: "https://youtu.be/YVVeeDCMQUc" },
  { id: 37,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 이차방정식의 근의 위치",                    link: "https://youtu.be/us-yBI9ECX0" },
  { id: 36,  main: "고등수학", sub: "공통수학1", title: "[실전문제풀이] 공통수학1 - 이차방정식과 함수",              link: "https://youtu.be/NUb4dajO-7c" },
  { id: 128, main: "고등수학", sub: "공통수학1", title: "실전문제풀이 - 공통수학 - 이차방정식",                     link: "https://youtu.be/ctHXIcdyc5Y" },
  // 이차함수
  { id: 40,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 이차함수와 이차방정식의 관계",               link: "https://youtu.be/hNKtbcACcKY" },
  { id: 39,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 이차함수의 그래프와 직선의 위치관계",        link: "https://youtu.be/isLYY_zv1Dk" },
  { id: 38,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 이차함수의 최대최소",                       link: "https://youtu.be/2u-6i3lMQY8" },
  { id: 9,   main: "고등수학", sub: "공통수학1", title: "[실전문제] 공통수학1 - 이차함수의 최대최소 1",            link: "https://youtu.be/koZzFC1I9k4" },
  { id: 8,   main: "고등수학", sub: "공통수학1", title: "[실전문제] 공통수학1 - 이차함수의 그래프 최대최소 2",      link: "https://youtu.be/Oi4DqfuZK5U" },
  { id: 1,   main: "고등수학", sub: "공통수학1", title: "[실전문제풀이] 공통수학1 - 이차함수의 최대최소",           link: "https://youtu.be/jWr9iiChq00" },
  { id: 33,  main: "고등수학", sub: "공통수학1", title: "실전문제 - 공통수학1 - 이차함수",                         link: "https://youtu.be/koZzFC1I9k4" },
  { id: 131, main: "고등수학", sub: "공통수학1", title: "실전문제풀이 - 공통수학1 - 이차함수",                     link: "https://youtu.be/3Z23igmlKfk" },
  { id: 134, main: "고등수학", sub: "공통수학1", title: "실전문제풀이 - 공통수학1 - 이차함수 (3:54)",               link: "https://youtu.be/GKKBIGgrAO8" },
  { id: 135, main: "고등수학", sub: "공통수학1", title: "실전문제풀이 - 공통수학1 - 이차함수 (6:42)",               link: "https://youtu.be/_-FksqdD3f0" },
  // 삼차/사차방정식
  { id: 48,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 삼사차방정식",                              link: "https://youtu.be/6CBLLjlWXl0" },
  { id: 47,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 삼사차방정식 치환",                         link: "https://youtu.be/CsVfDP_OgiY" },
  { id: 46,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 삼차방정식 근과 계수와의 관계",              link: "https://youtu.be/EoAARCQWxK0" },
  { id: 2,   main: "고등수학", sub: "공통수학1", title: "[실전문제풀이] 공통수학1 - 삼차방정식",                   link: "https://youtu.be/LOnxOGG6N6w" },
  // 연립방정식 / 부등식
  { id: 45,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 연립방정식",                               link: "https://youtu.be/Gie_czefguM" },
  { id: 44,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 일차부등식",                               link: "https://youtu.be/TLF9MbY9Lok" },
  { id: 43,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 이차부등식",                               link: "https://youtu.be/_B57jLixKCc" },
  // 행렬
  { id: 85,  main: "고등수학", sub: "공통수학1", title: "고등수학 공통수학 1 - 행렬",                              link: "https://youtu.be/bsF0oKZHsh4" },
  { id: 86,  main: "고등수학", sub: "공통수학1", title: "고등수학 공통수학 1 - 행렬의 연산",                        link: "https://youtu.be/lSWlr_WJGts" },
  { id: 87,  main: "고등수학", sub: "공통수학1", title: "고등수학 공통수학 1 행렬 - 케일리 해밀턴 정리",             link: "https://youtu.be/rbJMuKDlRDM" },
  // 경우의 수 / 순열 / 조합
  { id: 29,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 경우의 수 합과 곱의 법칙",                 link: "https://youtu.be/uDh9-yA2SUE" },
  { id: 88,  main: "고등수학", sub: "공통수학1", title: "고등 공통수학1 경우의 수 순열",                            link: "https://youtu.be/9fgT-3QevCM" },
  { id: 89,  main: "고등수학", sub: "공통수학1", title: "고등수학 공통수학1 - 조합",                               link: "https://youtu.be/E-1VTc8jQMI" },

  // ──────────────── 공통수학2 ────────────────
  // 두 점 사이의 거리 / 내분점 / 무게중심
  { id: 113, main: "고등수학", sub: "공통수학2", title: "고등 공통수학2 두점사이의거리 평면",                       link: "https://youtu.be/D4_SbGwenPU" },
  { id: 114, main: "고등수학", sub: "공통수학2", title: "고등수학 공통수학 2 - 두점사이의 거리",                    link: "https://youtu.be/v5HOjOkkMvI" },
  { id: 115, main: "고등수학", sub: "공통수학2", title: "고등수학 공통수학2 - 선분의 내분점",                       link: "https://youtu.be/LwxLRiQO2Sc" },
  { id: 34,  main: "고등수학", sub: "공통수학2", title: "고등수학 공통수학2 - 삼각형의 무게중심",                   link: "https://youtu.be/Yx6LsIw4OzQ" },
  // 직선의 방정식
  { id: 116, main: "고등수학", sub: "공통수학2", title: "고등수학 - 공통수학2 직선의 방정식 기울기 절편 복습",      link: "https://youtu.be/d7rwunbttgU" },
  { id: 117, main: "고등수학", sub: "공통수학2", title: "고등수학 - 공통수학2 직선의 방정식 유도 기울기와 한점이 주어진 경우", link: "https://youtu.be/8wRObiGPZEA" },
  { id: 118, main: "고등수학", sub: "공통수학2", title: "고등수학 - 공통수학2 직선의 방정식 유도 두점 또는 절편이 주어진 경우", link: "https://youtu.be/eL8P0t5UBfo" },
  { id: 119, main: "고등수학", sub: "공통수학2", title: "고등수학 - 공통수학2 정점을 지나는 직선의 방정식",         link: "https://youtu.be/5OSim0Bkvqw" },
  { id: 120, main: "고등수학", sub: "공통수학2", title: "고등수학 - 공통수학2 직선의 방정식 문제풀이",              link: "https://youtu.be/sXyhtsIIbIM" },
  { id: 121, main: "고등수학", sub: "공통수학2", title: "고등수학 - 공통수학2 일차방정식과 직선의 방정식의 관계",   link: "https://youtu.be/MAcJv_yDIWY" },
  // 두 직선의 위치관계
  { id: 122, main: "고등수학", sub: "공통수학2", title: "고등수학 - 공통수학2 두 직선의 위치관계 - 평행 일치",      link: "https://youtu.be/58yUsItNmfc" },
  { id: 123, main: "고등수학", sub: "공통수학2", title: "고등수학 - 공통수학2 두 직선의 위치관계 수직인경우",        link: "https://youtu.be/L4aW5F81yI4" },
  // 원의 방정식 / 도형의 이동
  { id: 124, main: "고등수학", sub: "공통수학2", title: "고등수학 - 공통수학2 원의 방정식",                         link: "https://youtu.be/HeAQcP5H414" },
  { id: 125, main: "고등수학", sub: "공통수학2", title: "고등수학 - 공통수학2 원과 직선의 위치관계",                link: "https://youtu.be/C6Mam2Yx7Zg" },
  { id: 126, main: "고등수학", sub: "공통수학2", title: "고등수학 - 공통수학2 도형의 평행이동",                     link: "https://youtu.be/qTf0QBa-UHs" },

  // ──────────────── 대수 ────────────────
  // 지수법칙 / 거듭제곱근
  { id: 77,  main: "고등수학", sub: "대수", title: "고등수학 대수 1강 지수법칙",                                link: "https://youtu.be/UOEKhovGsuY" },
  { id: 76,  main: "고등수학", sub: "대수", title: "고등수학 대수 2강 거듭제곱근",                              link: "https://youtu.be/F9FVncpk92Q" },
  { id: 75,  main: "고등수학", sub: "대수", title: "고등수학 대수 3강 거듭제곱근의 성질",                        link: "https://youtu.be/ckVIuyS5F78" },
  { id: 74,  main: "고등수학", sub: "대수", title: "고등수학 대수 4강 지수의 확장 - 정수지수",                   link: "https://youtu.be/NIMNf0vb3Eo" },
  { id: 73,  main: "고등수학", sub: "대수", title: "고등수학 대수 5강 지수의 확장 - 유리수 실수 지수",           link: "https://youtu.be/JxR4bWo32uU" },
  // 로그
  { id: 72,  main: "고등수학", sub: "대수", title: "고등수학 대수 6강 로그의 정의",                             link: "https://youtu.be/AFXf3lTaPzI" },
  { id: 71,  main: "고등수학", sub: "대수", title: "고등수학 대수 7강 로그의 성질(1)",                          link: "https://youtu.be/-Ic0wPy5-zQ" },
  { id: 70,  main: "고등수학", sub: "대수", title: "고등수학 대수 8강 로그의 성질(2)",                          link: "https://youtu.be/vB8LgUIsQlo" },
  { id: 69,  main: "고등수학", sub: "대수", title: "고등수학 대수 9강 상용로그",                                link: "https://youtu.be/EkR0z_bqPxc" },
  // 지수함수 / 로그함수
  { id: 68,  main: "고등수학", sub: "대수", title: "고등수학 대수 10강 지수함수 그래프",                         link: "https://youtu.be/eIQLnpRAdEo" },
  { id: 67,  main: "고등수학", sub: "대수", title: "고등수학 대수 11강 지수함수의 최대최소",                     link: "https://youtu.be/EluXlZuEpUU" },
  { id: 66,  main: "고등수학", sub: "대수", title: "고등수학 대수 12강 지수방정식",                             link: "https://youtu.be/PUsyHkySMjQ" },
  { id: 65,  main: "고등수학", sub: "대수", title: "고등수학 대수 13강 로그함수의 그래프",                       link: "https://youtu.be/dke9dmsLkJc" },
  { id: 64,  main: "고등수학", sub: "대수", title: "고등수학 대수 14강 로그함수의 최대최소",                     link: "https://youtu.be/EEamjAvQzyY" },
  { id: 63,  main: "고등수학", sub: "대수", title: "고등수학 대수 15강 로그방정식",                             link: "https://youtu.be/Dmj2LgB4H9I" },
  { id: 11,  main: "고등수학", sub: "대수", title: "[실전문제풀이] 대수 - 지수로그함수 그래프",                   link: "https://youtu.be/QqjN4unTXFI" },
  { id: 14,  main: "고등수학", sub: "대수", title: "[실전기출문제] 지수로그함수",                               link: "https://youtu.be/g5K5Sv92PLI" },
  // 삼각함수
  { id: 62,  main: "고등수학", sub: "대수", title: "고등수학 대수 삼각함수 일반각",                             link: "https://youtu.be/TyD6lX_1em4" },
  { id: 61,  main: "고등수학", sub: "대수", title: "고등수학 대수 삼각함수 호도법",                             link: "https://youtu.be/SAvwmbwPGRQ" },
  { id: 60,  main: "고등수학", sub: "대수", title: "고등수학 대수 삼각함수 부채꼴의 호의 길이와 넓이",           link: "https://youtu.be/j3QEtyZOkQA" },
  { id: 59,  main: "고등수학", sub: "대수", title: "고등수학 대수 삼각함수의 정의",                             link: "https://youtu.be/UQJUhVKwQRU" },
  { id: 58,  main: "고등수학", sub: "대수", title: "고등수학 대수 삼각함수의 성질",                             link: "https://youtu.be/XpnM_mBVHL4" },
  { id: 98,  main: "고등수학", sub: "대수", title: "고등수학 대수 - 삼각함수그래프",                              link: "https://youtu.be/bQ4y_iafpy4" },
  { id: 99,  main: "고등수학", sub: "대수", title: "고등수학 대수 - 특수각의 삼각비와 각변환 공식 문제풀이",         link: "https://youtu.be/fcDmmoJ6_a0" },
  { id: 10,  main: "고등수학", sub: "대수", title: "[실전문제풀이] 대수 - 삼각함수",                            link: "https://youtu.be/BWEEITiAyWo" },
  { id: 12,  main: "고등수학", sub: "대수", title: "[실전문제풀이] 대수 - 삼각함수 사인법칙",                    link: "https://youtu.be/ZNKwBskkx5M" },
  // 수열 / 귀납적 정의 / 수학적 귀납법
  { id: 96,  main: "고등수학", sub: "대수", title: "고등수학 대수 - 등차수열의 일반항",                           link: "https://youtu.be/hjlJRqJTzHc" },
  { id: 97,  main: "고등수학", sub: "대수", title: "고등수학 대수 - 등차수열의 합",                              link: "https://youtu.be/eUU-EmYdGds" },
  { id: 90,  main: "고등수학", sub: "대수", title: "고등수학 - 대수 수열의 귀납적 정의1",                         link: "https://youtu.be/BEtP-liKHu8" },
  { id: 91,  main: "고등수학", sub: "대수", title: "고등수학 - 대수 수열의 귀납적 정의 2",                        link: "https://youtu.be/mV7uHHKDe6s" },
  { id: 92,  main: "고등수학", sub: "대수", title: "고등수학 - 대수 수열의 귀납적 정의3",                         link: "https://youtu.be/Gy8bS0a2uTA" },
  { id: 93,  main: "고등수학", sub: "대수", title: "고등수학 - 대수 수열의 귀납적 정의4",                         link: "https://youtu.be/lJVXnenYpHI" },
  { id: 94,  main: "고등수학", sub: "대수", title: "고등수학 - 대수 수열의 귀납적 정의5",                         link: "https://youtu.be/o7LvO8OvjIQ" },
  { id: 95,  main: "고등수학", sub: "대수", title: "고등수학 - 대수 수학적 귀납법",                              link: "https://youtu.be/mN4lRwt2byk" },
  { id: 15,  main: "고등수학", sub: "대수", title: "[실전기출문제] 수열의 귀납적 정의",                          link: "https://youtu.be/5Io1O3jED-s" },
  { id: 13,  main: "고등수학", sub: "대수", title: "[실전문제풀이] 대수 - 수학적 귀납법",                        link: "https://youtu.be/Or5wlUKQj8w" },
  { id: 139, main: "고등수학", sub: "대수", title: "90%가 여기서 막힙니다 | 수열 귀납적 정의 | 25년 5월 모의고사", link: "https://youtu.be/M-3A5zWm57Q" },
  { id: 140, main: "고등수학", sub: "대수", title: "90%가 여기서 막힙니다 | 수열 귀납적 정의",                    link: "https://youtu.be/D_CW_uKRg3w" },

  // ──────────────── 미적분 ────────────────
  // 함수의 극한 / 연속
  { id: 84,  main: "고등수학", sub: "미적분", title: "고등수학 미적분 1강 함수의 극한에 대한 성질",               link: "https://youtu.be/SiS0Wgm6ocU" },
  { id: 100, main: "고등수학", sub: "미적분", title: "고등수학 미적분 - 함수의 극한에 대한 성질",               link: "https://youtu.be/z3ws0UUaISE" },
  { id: 82,  main: "고등수학", sub: "미적분", title: "고등수학 미적분 3강 함수의 극한의 응용",                    link: "https://youtu.be/SQTxZOg9V_k" },
  { id: 18,  main: "고등수학", sub: "미적분", title: "[실전문제풀이] 미적분 - 함수의 극한 연속함수의 성질",         link: "https://youtu.be/vRPNXUYsCjQ" },
  { id: 83,  main: "고등수학", sub: "미적분", title: "고등수학 미적분 2강 함수의 연속",                          link: "https://youtu.be/1yJaeL-cV4w" },
  { id: 101, main: "고등수학", sub: "미적분", title: "고등수학 미적분 미분가능과 연속",                         link: "https://youtu.be/1xr6SKCq4_s" },
  // 미분
  { id: 81,  main: "고등수학", sub: "미적분", title: "고등수학 미적분 1강 평균변화율",                           link: "https://youtu.be/1N9hj3Tfps0" },
  { id: 80,  main: "고등수학", sub: "미적분", title: "고등수학 미적분 2강 미분계수",                             link: "https://youtu.be/fk6agP-amk4" },
  { id: 79,  main: "고등수학", sub: "미적분", title: "고등수학 미적분 3강 도함수",                               link: "https://youtu.be/CHT2PpdwGjc" },
  { id: 78,  main: "고등수학", sub: "미적분", title: "고등수학 미적분 4강 미분법 공식",                          link: "https://youtu.be/xEFb8KOndH4" },
  { id: 102, main: "고등수학", sub: "미적분", title: "고등수학 미적분 - 미분법 기본공식 2",                     link: "https://youtu.be/gCiwTEv4b2E" },
  { id: 103, main: "고등수학", sub: "미적분", title: "고등수학 미적분 - 미분법 공식 3",                        link: "https://youtu.be/UNMHdH1f3-A" },
  { id: 104, main: "고등수학", sub: "미적분", title: "고등수학 미적분 1 - 접선의 방정식",                      link: "https://youtu.be/G2H2JVjilRU" },
  { id: 105, main: "고등수학", sub: "미적분", title: "고등수학 미적분1 - 평균값 정리",                         link: "https://youtu.be/IwRt78V8DdM" },
  { id: 106, main: "고등수학", sub: "미적분", title: "고등수학 미적분1 - 평균값 정리 증명",                     link: "https://youtu.be/R0SgO1Q49UA" },
  { id: 17,  main: "고등수학", sub: "미적분", title: "[실전문제풀이] 미적분 - 미분의 활용 함수의 최대최소",         link: "https://youtu.be/P8wZB9EqJxc" },
  { id: 141, main: "고등수학", sub: "미적분", title: "실전문제풀이 - 미적분 - 미분법 활용",                        link: "https://youtu.be/e9oswIwLlE8" },
  { id: 142, main: "고등수학", sub: "미적분", title: "실전기출문제 - 미적분 - 도함수의 그래프와 함수의 극값",         link: "https://youtu.be/nk_NsXs7dYs" },
  // 삼각함수 (사인/코사인 법칙 / 넓이)
  { id: 108, main: "고등수학", sub: "미적분", title: "고등수학 미적분 - 사인법칙",                             link: "https://youtu.be/O4THjEmjjBc" },
  { id: 107, main: "고등수학", sub: "미적분", title: "고등수학 미적분 - 코사인법칙",                           link: "https://youtu.be/wefnEVl0duM" },
  { id: 109, main: "고등수학", sub: "미적분", title: "고등수학 미적분 - 삼각방정식 부등식",                     link: "https://youtu.be/amB79RlsJ_Q" },
  { id: 111, main: "고등수학", sub: "미적분", title: "고등수학 미적분 - 삼각형의 넓이",                        link: "https://youtu.be/59oahhSo51M" },
  { id: 110, main: "고등수학", sub: "미적분", title: "고등 미적분 사각형의 넓이",                             link: "https://youtu.be/XZDoOh30H5Q" },
  // 적분
  { id: 132, main: "고등수학", sub: "미적분", title: "실전문제풀이 - 미적분 - 부정적분",                         link: "https://youtu.be/QGBFTUEEa6Q" },
  { id: 16,  main: "고등수학", sub: "미적분", title: "[실전문제풀이] 미적분 - 적분의 활용",                      link: "https://youtu.be/wl0Di1bohxo" },

  // ──────────────── 확률과 통계 ────────────────
  // 순열 / 중복순열
  { id: 19,  main: "고등수학", sub: "확률과 통계", title: "[실전문제풀이] 확률통계 - 중복순열",                   link: "https://youtu.be/B2AZrTtnXpE" },
  { id: 22,  main: "고등수학", sub: "확률과 통계", title: "[실전문제] 확률통계 - 중복순열",                      link: "https://youtu.be/DK22Io2sWm4" },
  { id: 20,  main: "고등수학", sub: "확률과 통계", title: "[실전문제풀이] 확률통계 - 같은것이 있는 순열",          link: "https://youtu.be/CbfcmyP4PIg" },
  // 중복조합
  { id: 21,  main: "고등수학", sub: "확률과 통계", title: "[실전문제풀이] 확률통계 - 중복조합",                   link: "https://youtu.be/CVbqRHsx0Xs" },
  { id: 133, main: "고등수학", sub: "확률과 통계", title: "실전문제풀이 - 확률통계 - 중복조합",                  link: "https://youtu.be/hK4fEx1DbrE" },
  // 확률분포 / 이산확률변수
  { id: 112, main: "고등수학", sub: "확률과 통계", title: "고등수학 - 확률통계 이산확률변수와 확률분포",          link: "https://youtu.be/aK0rflx5eKw" },
  { id: 26,  main: "고등수학", sub: "확률과 통계", title: "고등수학 - 확률통계 이산확률변수의 평균",               link: "https://youtu.be/CZBcps26IdE" },
  { id: 25,  main: "고등수학", sub: "확률과 통계", title: "고등수학 - 확률통계 이산확률변수의 분산과 표준편차",     link: "https://youtu.be/Xwn30A7FXV0" },
  { id: 24,  main: "고등수학", sub: "확률과 통계", title: "고등수학 - 확률통계 이산확률변수의 평균 분산과 표준편차", link: "https://youtu.be/qHID389cOZ4" },
  { id: 23,  main: "고등수학", sub: "확률과 통계", title: "고등수학 - 확률통계 이항분포",                        link: "https://youtu.be/9dn4MSMOwZc" },

  // ──────────────── 중등수학 ────────────────
  { id: 27, main: "중등수학", sub: "중등수학", title: "중등수학 중3-1 실전문제풀이 - 무리수의 대소관계",           link: "https://youtu.be/FE3OVz5XVAA" },
  { id: 28, main: "중등수학", sub: "중등수학", title: "중등수학 중3 실전문제풀이 - 제곱근",                       link: "https://youtu.be/ZBRPE7LFBsY" },
];

const highSubCategories: HighSubCategory[] = [
  "전체", "공통수학1", "공통수학2", "대수", "미적분", "확률과 통계",
];

const subStyle: Record<string, { badge: string; bg: string; icon: string }> = {
  공통수학1:    { badge: "bg-violet-100 text-violet-700", bg: "from-violet-500 to-violet-700",   icon: "ri-function-line" },
  공통수학2:    { badge: "bg-sky-100 text-sky-700",       bg: "from-sky-500 to-sky-700",         icon: "ri-function-line" },
  대수:        { badge: "bg-emerald-100 text-emerald-700", bg: "from-emerald-500 to-emerald-700", icon: "ri-superscript" },
  미적분:      { badge: "bg-orange-100 text-orange-700",  bg: "from-orange-500 to-orange-700",   icon: "ri-line-chart-line" },
  "확률과 통계": { badge: "bg-rose-100 text-rose-700",   bg: "from-rose-500 to-rose-700",       icon: "ri-bar-chart-line" },
  중등수학:    { badge: "bg-teal-100 text-teal-700",      bg: "from-teal-500 to-teal-700",       icon: "ri-book-2-line" },
};

function getYouTubeId(url: string): string | null {
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([A-Za-z0-9_-]{11})/);
  return match ? match[1] : null;
}

function VideoCard({ video }: { video: Video }) {
  const style = subStyle[video.sub] ?? {
    badge: "bg-slate-100 text-slate-600",
    bg: "from-slate-400 to-slate-600",
    icon: "ri-play-circle-line",
  };

  const videoId = getYouTubeId(video.link);
  const thumbnailUrl = videoId
    ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
    : null;

  return (
    <a
      href={video.link}
      target="_blank"
      rel="noopener noreferrer"
      className="bg-white rounded-2xl border border-slate-100 overflow-hidden hover:-translate-y-1 transition-all duration-300 cursor-pointer group"
    >
      {/* Thumbnail */}
      <div className="relative w-full h-40 overflow-hidden bg-slate-100">
        {thumbnailUrl ? (
          <>
            <img
              src={thumbnailUrl}
              alt={video.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors" />
          </>
        ) : (
          <div className={`w-full h-full bg-gradient-to-br ${style.bg} flex items-center justify-center`}>
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-play-fill text-white text-2xl ml-0.5" />
            </div>
          </div>
        )}
        {/* Play button overlay */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-12 h-12 bg-black/50 group-hover:bg-[#FF0000] rounded-full flex items-center justify-center transition-colors duration-300">
            <i className="ri-play-fill text-white text-2xl ml-0.5" />
          </div>
        </div>
        {/* YouTube badge */}
        <div className="absolute top-3 right-3 bg-black/60 rounded-md px-1.5 py-0.5 flex items-center gap-1">
          <i className="ri-youtube-line text-white text-xs" />
          <span className="text-white text-xs font-medium">YouTube</span>
        </div>
      </div>
      {/* Info */}
      <div className="p-4">
        <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${style.badge}`}>
          {video.sub}
        </span>
        <h3 className="font-bold text-slate-700 text-sm leading-snug mt-2 group-hover:text-[#2563EB] transition-colors">
          {video.title}
        </h3>
      </div>
    </a>
  );
}

function EmptyState() {
  return (
    <div className="col-span-3 flex flex-col items-center justify-center py-20 text-center">
      <div className="w-16 h-16 bg-slate-100 rounded-2xl flex items-center justify-center mb-4">
        <i className="ri-video-line text-2xl text-slate-400" />
      </div>
      <p className="text-slate-500 font-medium mb-1">아직 등록된 영상이 없습니다</p>
      <p className="text-slate-400 text-sm">곧 업로드될 예정입니다</p>
    </div>
  );
}

export default function Videos() {
  const [mainTab, setMainTab] = useState<MainCategory>("고등수학");
  const [highSub, setHighSub] = useState<HighSubCategory>("전체");

  const filtered = videos.filter((v) => {
    if (v.main !== mainTab) return false;
    if (mainTab === "고등수학" && highSub !== "전체") return v.sub === highSub;
    return true;
  });

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-[#1E3A5F] mb-4">동영상 자료실</h1>
          <p className="text-slate-500 text-lg">김희삼 원장님의 유튜브 강의 영상을 시청하세요</p>
        </div>

        {/* Main Tab */}
        <div className="flex justify-center mb-8">
          <div className="inline-flex bg-slate-100 rounded-full p-1">
            {(["중등수학", "고등수학"] as MainCategory[]).map((tab) => (
              <button
                key={tab}
                onClick={() => { setMainTab(tab); setHighSub("전체"); }}
                className={`px-8 py-2.5 rounded-full text-sm font-bold transition-colors whitespace-nowrap cursor-pointer ${
                  mainTab === tab
                    ? "bg-[#1E3A5F] text-white shadow-sm"
                    : "text-slate-500 hover:text-slate-700"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* 고등수학 Sub Filter */}
        {mainTab === "고등수학" && (
          <div className="flex justify-center gap-2 mb-10 flex-wrap">
            {highSubCategories.map((sub) => (
              <button
                key={sub}
                onClick={() => setHighSub(sub)}
                className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  highSub === sub
                    ? "bg-[#2563EB] text-white"
                    : "bg-white text-slate-600 border border-slate-200 hover:border-[#2563EB] hover:text-[#2563EB]"
                }`}
              >
                {sub}
              </button>
            ))}
          </div>
        )}

        {/* Video Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filtered.length > 0
            ? filtered.map((video) => <VideoCard key={video.id} video={video} />)
            : <EmptyState />}
        </div>

        {/* Channel Link */}
        <div className="text-center mt-12">
          <p className="text-sm text-slate-400 mb-4">더 많은 강의 영상은 유튜브 채널에서 확인하세요</p>
          <a
            href="https://www.youtube.com/@fma9422"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center whitespace-nowrap h-11 px-8 bg-[#FF0000] hover:bg-[#cc0000] text-white font-bold rounded-lg text-sm transition-colors cursor-pointer gap-2"
          >
            <i className="ri-youtube-line text-base" />
            유튜브 채널 바로가기 (211개 영상)
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}
